import { render } from "./CoursesFilter.vue?vue&type=template&id=75d9cfe2"
import script from "./CoursesFilter.vue?vue&type=script&lang=js"
export * from "./CoursesFilter.vue?vue&type=script&lang=js"

import exportComponent from "/opt/goodtoknow/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__